import { useContext } from 'react';

import { EQLFilterContext } from './context';

/** Read/control the popover's open state from anywhere inside `EQLFilter`. */
export function useEQLFilter() {
  const [open, setOpen] = useContext(EQLFilterContext);
  return { open, setOpen, close: () => setOpen(false) };
}
